module.exports = __webpack_public_path__ + "img/base_activites_speleologie.00b2161f.svg";